import $ from 'jquery';
import { storeSetting, loadSetting } from './common';

let propertyDisplayLO = null;

const element = `
  <div class=display-office>
    <h4 class=display-office__label>Display Listing Office</h4>
    <div class=display-office__container>
      <div class=display-office__all>
        <input id=showOfficeAll type=radio name=display-office>
        <label for=showOfficeAll>On All</label>
      </div>
      <div class=display-office__first>
        <input id=showOfficeFirst type=radio name=display-office>
        <label for=showOfficeFirst>First Image Only</label>
      </div>
      <div class=display-office__none>
        <input id=showOfficeNone type=radio name=display-office>
        <label for=showOfficeNone>No</label>
      </div>
    </div>
  </div>
`;

export default function displayOffice($parent, array) {
  const $dom = $(element);
  $parent.after($dom);
  saveLine(array);
  loadSetting('propertyDisplayLO')
    .then((r) => {
      if (r === '' || r === 'none') {
        setPropDisplayLO($dom, 'none', array);
      } else if (r === 'first') {
        setPropDisplayLO($dom, 'first', array);
      } else if (r === 'all') {
        setPropDisplayLO($dom, 'all', array);
      }
    })
    .catch(() => window.onbeforeunload && alert('Could not load display office setting'));

  $dom.find('#showOfficeAll').on('change', () => {
    saveLine(array);
    setPropDisplayLO($dom, 'all', array);
  });
  $dom.find('#showOfficeFirst').on('change', () => {
    if (propertyDisplayLO === 'none') { saveLine(array); }
    setPropDisplayLO($dom, 'first', array);
  });
  $dom.find('#showOfficeNone').on('change', () => {
    setPropDisplayLO($dom, 'none', array);
  });
}

function saveLine(properties) {
  properties.forEach((e) => {
    // eslint-disable-next-line
    e.store_line = e.lines[1];
  });
}

function setPropDisplayLO($dom, v, properties) {
  storeSetting('propertyDisplayLO', v)
    .then(() => {
      if (v === 'all') {
        $dom.find('#showOfficeAll').attr('checked', 'checked');
        properties.forEach((e) => {
          e.displayListingOffice = true;
          e.lines[1] = '[listing_office]';
          $(e.dom).find('.creative-item__second-sub')
            .addClass('do-not-change')
            .val(e.lines[1])
            .trigger('keyup');
        });
        $('.image-picker').addClass('image-picker--courtesy');
      } else if (v === 'first') {
        updateFirst();
        $dom.find('#showOfficeFirst').attr('checked', 'checked');
        $('.image-picker__item').on('click', updateFirst);
        $('.image-picker')
          .removeClass('image-picker--courtesy')
          .addClass('image-picker--only-first');
        /* eslint-disable */
        function updateFirst() {
          $('.creative-item__remove-item').on('click', updateFirst);
          setTimeout(() => {
            const firstSel = $($('.creative-item')[0]).attr('creativeorder');
            if (firstSel === undefined || firstSel === null) return false;
            properties.forEach((e, i) => {
              if (i !== Number(firstSel)) {
                e.displayListingOffice = false;
                e.lines[1] = e.store_line || '';
                $(e.dom).find('.creative-item__second-sub')
                  .removeClass('do-not-change')
                  .val(e.lines[1])
                  .trigger('keyup');
              } else { e.displayListingOffice = true; }
            });
            properties[firstSel].lines[1] = '[listing_office]';
            $(properties[firstSel].dom).find('.creative-item__second-sub')
              .addClass('do-not-change')
              .val(properties[firstSel].lines[1])
              .trigger('keyup');
          }, 600);
        }
        /* eslint-enable */
      } else if (v === 'none') {
        $dom.find('#showOfficeNone').attr('checked', 'checked');
        properties.forEach((e) => {
          e.displayListingOffice = false;
          e.lines[1] = e.store_line || '';
          $(e.dom).find('.creative-item__second-sub')
            .removeClass('do-not-change')
            .val(e.lines[1])
            .trigger('keyup');
        });
        $('.image-picker')
          .removeClass('image-picker--only-first')
          .removeClass('image-picker--courtesy');
      }
      propertyDisplayLO = v;
    })
    .catch(() => { alert('Could not save display office setting'); });
}
